<template>
  <li
    class="pp-event-item"
    :class="additionalClasses"
    @click="selectItem(itemInfo.CRMEventID)"
    @keydown.enter="selectItem(itemInfo.CRMEventID)"
    tabindex="0"
  >
    <span class="pp-event-item__event-notice">
      <font-awesome-icon
        v-show="itemSelected"
        icon="check-circle"
        class="event-notice event-notice--selected"
      />
      <font-awesome-icon
        v-show="ticketSelectable && !itemSelected"
        icon="circle"
        class="event-notice event-notice--no"
      />
    </span>
    <span class="pp-event-item__date">
      <template v-if="shouldDisplayShowTitle">{{ showTitle }}</template>
      <template v-if="shouldDisplayShowTitle && shouldDisplayLocalisedDate"> - </template>
      <template v-if="shouldDisplayLocalisedDate">{{ localisedDate }}</template>
    </span>
    <span
      class="pp-event-item__status"
      :class="statusClasses"
      v-if="!ticketSelectable"
    >
      <span v-t="statusText()"></span>
    </span>
  </li>
</template>

<script>
import DateTimeItems from "@/util/DateTimeItems.js";
import _ from "lodash";

export default {
  name: "session-item",
  mixins: [DateTimeItems],
  props: ["itemStatus","showTitle","shouldDisplayShowTitle","shouldDisplayLocalisedDate"],
  computed: {
    ticketSelectable() {
      return this.statusText() === "";
    },
    additionalClasses() {
      let additionalClasses = [];
      if (!this.ticketSelectable) {
        additionalClasses.push("pp-event-item--disabled");
      }
      if (this.eventSelected) {
        additionalClasses.push("pp-event-item--selected");
      }

      return additionalClasses;
    },
    statusClasses() {
      if (!this.ticketSelectable) {
        return "pp-event-item__status--16";
      } else {
        return ""
      }
    },
  },
  methods: {
     selectItem(id) {
      if (this.itemSelected) {
        // already selected, deselect
        this.$emit("selectItem", null);
      } else if (this.ticketSelectable) {
        // event isn't selected and *is* selectable
        this.$emit("selectItem", id);
      }
    },
    statusText() {
      if (_.get(this.itemStatus, "status") !== 'open') {
        return "session.status." + _.get(this.itemStatus, "status");
      }

      return "";
    },
  },
};
</script>
